import Resource from '@/services/resources/common';

export default class ConfigurationResource extends Resource {
  constructor(entrypoint = '/configurations', alias = 'Configuration') {
    super(entrypoint, alias);
  }
}
